import ServicePage from "./page";
import { healthInsuranceData } from "@/mocks/insurancePages";

export default function HealthInsurance() {
  return <ServicePage data={healthInsuranceData} />;
}